import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ProductModel } from '../../../models/master-data/products.model';
import { Observable } from 'rxjs/Observable';
import { InvoicePayMethodModel } from '../../../models/consultation/cash-sale.model';
import { InvoiceUrl } from '../../../shared/urls/invoice.url'
import { Utility } from '../../../common/utility';

@Injectable()
export class PayMethodPopupService {
	constructor(public baseService: BaseService) {
	}

	getInfoInvoice(invoiceId: string): Observable<any> {
		const url = InvoiceUrl.GET_INVOICE_PAYMENT_METHOD;
		if (invoiceId) {
			return this.baseService.getData(url, { id: invoiceId });
		}
		return this.baseService.getData(url);
	}

	getEditInvoicePaymethod(invoiceId, currencyCode) {
		let url = Utility.stringFormat(InvoiceUrl.GET_ACCONT_PAYMENT_INVOICE_PAYMETHOD, [invoiceId]);
		if (!invoiceId) {
			url = InvoiceUrl.UPDATE_ACCONT_PAYMENT_INVOICE_PAYMETHOD;
		}
		return this.baseService.getData(url, { currencyCode: currencyCode });
	}

	updateEditInvoicePaymethod(data) {
		const url = InvoiceUrl.UPDATE_ACCONT_PAYMENT_INVOICE_PAYMETHOD;
		return this.baseService.put(url, data);
	}

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/pay-method-popup.service.ts